import { render, staticRenderFns } from "./AddSatellite.vue?vue&type=template&id=15a126d6&"
import script from "./AddSatellite.vue?vue&type=script&lang=js&"
export * from "./AddSatellite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports